import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './slices/rootReducer';
import rootSaga from './sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ 
      thunk: false,
      serializableCheck: {
        ignoredActions: [
          'imageUpload/uploadImageRequest',
          'aiImageGeneration/generateImagesRequest'
        ],
        ignoredActionsPaths: ['payload'],
        ignoredPaths: [
          'imageUpload.uploadingFile',
          'aiImageGeneration.data'
        ],
      }
    }).concat(sagaMiddleware),
  devTools: import.meta.env.MODE !== 'production',
});

sagaMiddleware.run(rootSaga);

export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
